import AdminsService from '../../services/admins.service.js';
import NotificationsService from '../../services/notifications.service.js';
import GroupsService from '../../services/groups.service.js';

const LIMIT_ERROR = 'CREATORS_LIMIT_REACHED';

export const state = {
  admin: null,
  showLimitError: null,
  notifications: [],
  groups: [],
  admins: []
};

export const mutations = {
  SET_ADMIN(state, admin) {
    state.admin = admin;
  },
  SET_ADMINS(state, admins) {
    state.admins = admins;
  },
  SET_ADMIN_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications;
  },
  SET_ADMIN_GROUPS(state, groups) {
    state.groups = groups;
  },
  SET_ADMIN_LIMIT_ERROR(state, showLimitError) {
    state.showLimitError = showLimitError;
  },
  CLEAR_ADMIN(state) {
    state.notifications = [];
    state.admin = {};
    state.groups = [];
  }
};
export const getters = {
  isExpert(state) {
    const role = state.admin ? state.admin.role : '';
    if (role === 'expert' || role === 'distributor') {
      return true;
    }
    return false;
  }
};

export const actions = {
  async getAdminData({ commit, dispatch, getters }, adminId) {
    try {
      const { data: adminData } = await AdminsService.getAdminData(adminId);
      const isExpert = getters.isExpert;

      commit('SET_ADMIN', adminData);
      await dispatch('getAdminNotifications', {
        'recipient.entityId': adminData.id
      });

      if (isExpert) {
        await dispatch('getAdminGroups', { agentIds: adminData.id });
      }
      return adminData;
    } catch (err) {
      console.error(err);
    }
  },
  async getAdmins({ commit }, query) {
    try {
      const { data: admins } = await AdminsService.fetchAdmins(query);
      commit('SET_ADMINS', admins);
    } catch (err) {
      console.error(err);
    }
  },
  async createAdmin({ commit, dispatch, rootState }, { admin, notification }) {
    try {
      const { distributorId, selectedClientId, clientId } = rootState.profile.profileData;
      if (selectedClientId) {
        admin.clientIds = [selectedClientId];
        admin.selectedClientId = selectedClientId;
      } else {
        admin.clientIds = [clientId];
        admin.distributorId = distributorId;
      }
      const { data: responseData } = await AdminsService.createAdmin(admin);
      if (responseData) {
        commit('SET_ADMIN', responseData);
        dispatch('addNotification', notification);
      }
      return responseData;
    } catch (error) {
      if (error.response.data.errorCode === LIMIT_ERROR) {
        dispatch('showLimitError');
      }
      console.error(error);
    }
  },
  async updateAdmin({ commit, dispatch }, { admin, notification }) {
    try {
      const { data: adminResponse } = await AdminsService.updateAdmin(admin);
      if (adminResponse) {
        commit('SET_ADMIN', adminResponse);
        dispatch('addNotification', notification);
      }
      return adminResponse;
    } catch (err) {
      const errorNotification = {
        type: 'error',
        message: `feedback.errors.updateClient`,
        show: notification.show
      };
      dispatch('addNotification', errorNotification);
      console.error(err);
    }
  },
  async getAdminNotifications({ commit }, query) {
    try {
      const { data: docs } = await NotificationsService.fetchEmails(query);
      commit('SET_ADMIN_NOTIFICATIONS', docs);
    } catch (err) {
      console.error(err);
    }
  },
  async resendEmail({ dispatch }, admin) {
    try {
      await NotificationsService.resendEmail(admin);
      const notification = {
        type: 'success',
        message: `feedback.success.resendEmail`,
        show: true
      };
      dispatch('addNotification', notification);
    } catch (err) {
      const notification = {
        type: 'error',
        message: `feedback.error.resendEmail`,
        show: true
      };
      dispatch('addNotification', notification);
      console.error(err);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  async getAdminGroups({ commit }, query) {
    try {
      const { data: docs } = await GroupsService.fetchGroups(query);
      commit('SET_ADMIN_GROUPS', docs);
    } catch (err) {
      console.error(err);
    }
  },
  async showLimitError({ commit, dispatch, rootState }) {
    const { role } = rootState.profile.profileData;
    if (role === 'expert' || role === 'distributor') {
      dispatch('getDistributorDate');
      commit('SET_ADMIN_LIMIT_ERROR', true);
    }
  }
};
